module.exports = __webpack_public_path__ + "img/pattern.d77cd703.svg";